import {X} from "react-feather";
import {toggleBodyScroll} from "utils";
import {useEffect, useState} from "react";
import {useTheme} from "styled-components";
import {Absolute} from "components/@system";
import {IconButton} from "components/@button";
import {AnimatePresence} from "framer-motion";
import {closeMultimedia} from "global/slices";
import {useAppDispatch, useAppSelector, useBreakpoints} from "hooks";
import {Container, MainImage, Thumbnail, Thumbnails, Grid} from "./styled";

interface MultimediaProps {}

export const Multimedia: React.FC<MultimediaProps> = () => {
  const {upMd} = useBreakpoints();
  const dispatch = useAppDispatch();
  const {white, white01, primary} = useTheme();
  const [main, setMain] = useState<string>("");
  const {shown, assets} = useAppSelector("multimedia");

  useEffect(() => {
    toggleBodyScroll(shown);
  }, [shown]);
  useEffect(() => {
    setMain(assets[0]);
  }, [assets]);

  return (
    <AnimatePresence>
      {shown && (
        <Container
          exit={{opacity: 0, transform: "translateY(2rem)"}}
          initial={{opacity: 0, transform: "translateY(1rem)"}}
          animate={{opacity: 1, transform: "translateY(0rem)"}}
        >
          <Grid>
            <Thumbnails>
              {assets.map((src, key) => (
                <Thumbnail
                  key={key}
                  src={src}
                  onClick={() => setMain(src)}
                  style={{
                    border: `3px solid ${
                      src === main ? primary : "transparent"
                    }`,
                  }}
                />
              ))}
            </Thumbnails>
            <MainImage src={main} />
          </Grid>
          <Absolute top={upMd ? 10 : 15} right={upMd ? 10 : 15}>
            <IconButton
              backgroundColor={white01}
              icon={<X color={white} />}
              onClick={() => dispatch(closeMultimedia())}
            />
          </Absolute>
        </Container>
      )}
    </AnimatePresence>
  );
};
